import React from "react";

import Hero from "./components/Hero";
import About from "./components/About";
import Experience from "./components/Experience";
import Skills from "./components/Skills";
import Contact from "./components/Contact";
import Navigation from "./components/Navigation";

export default function App() {
  return (
    <div className="min-h-screen bg-paper text-ink">
      <Navigation />

      <main>
        <section id="hero">
          <Hero />
        </section>

        <section id="experience" className="bg-ink text-paper">
          <Experience />
        </section>

        <section id="skills">
          <Skills />
        </section>

        <section id="about" className="border-t border-ink">
          <About />
        </section>

        <section id="contact" className="bg-vermilion text-ink">
          <Contact />
        </section>
      </main>
    </div>
  );
}
